<template>
  <div>
    <div class="row1">
      <div>
        <el-button
          @click="onAdd"
          class="row-btn add"
          type="primary"
          size="small"
          >添加</el-button
        >
      </div>
    </div>
    <div class="tab-box">
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection"> </el-table-column> -->
      <!-- <el-table-column label="序号" width="55" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column> -->
		<el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column prop="title" label="名称"> </el-table-column>
        <el-table-column label="轮播图">
			<template slot-scope="scope">
				<el-image
				  style="width: 120px; height: 80px"
				  :src="scope.row.image"
				>
				</el-image>
			</template>
		</el-table-column>
		<el-table-column prop="url" label="链接"> </el-table-column>
        <el-table-column label="状态">
			<template slot-scope="scope">
				<el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
				<el-tag v-else type="warning">禁用</el-tag>
			</template>
		</el-table-column>
		<el-table-column prop="sort" label="排序"> </el-table-column>
		<el-table-column prop="create_time" label="创建时间"> </el-table-column>
		
        <el-table-column label="操作"  align="center">
          <template slot-scope="scope">
            <div class="handle-box">
              <span class="txt-btn txtC" @click="handleEdit(scope.row)"
                >修改</span
              >
              <span class="txt-btn del-txt" @click="handleDel(scope.row)"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="page-box">
        <el-pagination
		 v-if="tableData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
	<!-- <examine ref="examineDialog" @examine="onExamine"></examine> -->
	<!-- <dialog-date ref="dateDialog" @date="onDate"></dialog-date> -->
  </div>
</template>

<script>
	// import examine from '../../components/dialog/reportExamine.vue'
	// import dialogDate from '../../components/dialog/reportDate.vue'
export default {
	components:{
		// examine,
		// dialogDate
	},
  data() {
    return {
		id:'',
      tableData: [],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		filter: {},
		op: {}
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
      searchVal: "", //搜索框值
    };
  },
  created() {
	  // console.log(this.$route);
	  this.id = this.$route.query.id;
    this.getList();
  },
  methods: {
    // 添加
    onAdd() {
        this.$router.push({ path: "/sys_setBanner",query: {type: 1} });
    },
	//修改
	handleEdit(v){
		v.type = 2
		this.$router.push({ path: "/sys_setBanner",query: v });
	},
	// 删除
	handleDel(v){
		this.$confirm('确认删除：'+v.title+' ？', '提示').then(() => {
			 this.$api2.delBanner({id:v.id}).then((res)=>{
			 	if(res.code == 1){
			 		this.$message.success(res.msg)
			 		this.getList()
			 	}else{
			 		this.$message.error(res.msg)
			 	}
			 })
		}).catch(()=>{})
	},
    // 获取数据列表
    getList() {
		this.loading = true;
      this.$api2.getBanner().then(res => {
      	this.loading = false;
      	if (res.code == 1) {
			//审批，关联信息跳转过来筛选数据
			if(this.id){
				this.total = 1
				res.data.forEach((v,k)=>{
					if(v.id == this.id){
						this.tableData = [v]
					}
				})
			}else{
				this.total = res.count;
				this.tableData = res.data;
			}
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/css/public.css";
.row1 {
  align-items: center;
  justify-content: space-between;
}
.search {
  margin-left: 10px;
  margin-right: 0 !important;
}
.handle-box {
    display: flex;
    justify-content: space-between;
	.txt-btn{
		margin: 5px 0;
	}
}
</style>